import React, { useState, useEffect } from 'react';
import { Trash2 } from 'lucide-react';
import { adminStatsService } from '../../../services/adminStatsService';
import { useSeasonContext } from '../../../context/SeasonContext';

const PickemItemBlock = ({ block, onUpdate, onDelete }) => {
  const [teams, setTeams] = useState([]);
  const { selectedSeason } = useSeasonContext();

  useEffect(() => {
    if (selectedSeason?.id) {
      fetchTeams();
    }
  }, [selectedSeason?.id]);

  const fetchTeams = async () => {
    try {
      const playerList = await adminStatsService.getPlayersForSeason(selectedSeason.id);
      const uniqueTeams = [...new Set(playerList.map(p => p.team).filter(Boolean))].sort();
      setTeams(uniqueTeams);
    } catch (error) {
      console.error('Error fetching teams:', error);
    }
  };

  return (
    <div className="block-item pickem-block">
      <div className="block-header">
        <span>Pickem</span>
        <button
          type="button"
          className="btn-icon-small delete"
          onClick={() => onDelete(block.id)}
        >
          <Trash2 size={16} />
        </button>
      </div>
      <select
        value={block.team1 || ''}
        onChange={(e) => onUpdate(block.id, { team1: e.target.value })}
        className="field-select"
      >
        <option value="">Select team 1</option>
        {teams.map((team) => (
          <option key={team} value={team}>
            {team}
          </option>
        ))}
      </select>
      <select
        value={block.team2 || ''}
        onChange={(e) => onUpdate(block.id, { team2: e.target.value })}
        className="field-select"
      >
        <option value="">Select team 2</option>
        {teams.map((team) => (
          <option key={team} value={team}>
            {team}
          </option>
        ))}
      </select>
      <select
        value={block.pick || 'team1'}
        onChange={(e) => onUpdate(block.id, { pick: e.target.value })}
        className="field-select"
      >
        <option value="team1">Team 1</option>
        <option value="team2">Team 2</option>
      </select>
      <select
        value={block.confidence || 'Medium'}
        onChange={(e) => onUpdate(block.id, { confidence: e.target.value })}
        className="field-select"
      >
        <option value="Low">Low</option>
        <option value="Medium">Medium</option>
        <option value="High">High</option>
      </select>
    </div>
  );
};

export default PickemItemBlock;
